import { useEffect, useState } from "react";

const useDeviceInfo = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    browser: "Unknown",
    os: "Unknown",
  });

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent;
      let browser = "Unknown";
      let os = "Unknown";

      // Detect OS
      if (userAgent.includes("Win")) os = "Windows";
      else if (userAgent.includes("Mac") && !userAgent.includes("iPhone") && !userAgent.includes("iPad")) os = "macOS";
      else if (userAgent.includes("Linux") && !userAgent.includes("Android")) os = "Linux";
      else if (userAgent.includes("Android")) os = "Android";
      else if (/iPhone|iPad|iPod/.test(userAgent)) os = "iOS";
      else if (userAgent.includes("CrOS")) os = "Chrome OS";

      // Detect Browser
      if (userAgent.includes("Edg/") || userAgent.includes("EdgA/") || userAgent.includes("EdgiOS/")) {
        browser = "Edge";
      } else if (userAgent.includes("OPR/") || userAgent.includes("OPR/")) {
        browser = "Opera";
      } else if (userAgent.includes("Firefox/") || userAgent.includes("FxiOS/")) {
        browser = "Firefox";
      } else if (userAgent.includes("Chrome/") || userAgent.includes("CriOS/")) {
        browser = "Chrome";
      } else if (userAgent.includes("Safari/") && !userAgent.includes("Chrome")) {
        browser = "Safari";
      } else if (userAgent.includes("Trident/") || userAgent.includes("MSIE")) {
        browser = "Internet Explorer";
      }

      // userAgentData support
      if (navigator.userAgentData) {
        const uaData = navigator.userAgentData;

        if (uaData.platform) {
          os = uaData.platform;
        }

        const chromiumBrand = uaData.brands?.find((b) => b.brand === "Microsoft Edge" || b.brand === "Opera" || b.brand === "Google Chrome" || b.brand === "Chromium");

        if (chromiumBrand) {
          if (chromiumBrand.brand === "Microsoft Edge") browser = "Edge";
          else if (chromiumBrand.brand === "Opera") browser = "Opera";
          else if (chromiumBrand.brand === "Google Chrome") browser = "Chrome";
          else if (chromiumBrand.brand === "Chromium") browser = "Chromium";
        }
      }

      setDeviceInfo({ browser, os });
    };

    detectDevice();
  }, []);

  return deviceInfo;
};

export default useDeviceInfo;
